import { NgModule } from '@angular/core';
import { NoPreloading, RouterModule, Routes } from '@angular/router';

const routes: Routes = [
    {
        path: '',
        loadChildren: () => import('./pages/pages.module').then((m) => m.PagesModule),
    },
];

@NgModule({
    imports: [
        RouterModule.forRoot(routes, {
            scrollPositionRestoration: 'top',
            anchorScrolling: 'enabled',
            preloadingStrategy: NoPreloading,
        }),
    ],
    exports: [RouterModule],
})
export class AppRoutingModule {}
